import Vue from 'vue';
import Vuex from 'vuex';
import lang from './module/language.js';
import userInfo from './module/userInfo.js';
import dict from './module/dict.js';
import tagsView from './module/tagsView.js';
import outUrl from './module/outUrl.js';
import authCode from './module/authCode.js';
import menu from './module/menu.js';
import app from './module/app.js';
import getters from './getters';

/**
 * 全局状态管理
 */
const state = {};
const mutations = {};

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    lang,
    userInfo,
    tagsView,
    dict,
    outUrl,
    authCode,
    menu,
    app,
  },
  getters,
});
